import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import projectsModel from '$$projectModel';
import ganttViewModel from '$$ganttViewModel';
import calculateCostChildTask from './calculateCostChildTask';
import rights from '../rights';

const getPriceForProjectTask = (task, ganttId) => {
  let totalPrice = 0;
  const children = globalStore.getters['tasksModel/getAllChildByTask'](ganttId, task.id);

  _.each(children, childTask => {
    if (childTask.type !== constants.TASK_TYPES.button) {
      const projectAutoBudget = projectsModel.getProjectAutoBudget(ganttId);

      if (childTask.type !== constants.TASK_TYPES.project && ((childTask.resources && childTask.resources.length) || !projectAutoBudget)) {
        totalPrice += calculateCostChildTask(childTask);
      }
    }
  });

  return totalPrice;
};

export default function (task, isBaseline, baselineModelState) {
  let totalPrice = 0;
  let ganttId = task.gantt_id;

  if (task.type === constants.TASK_TYPES.button) {
    return '';
  }

  if (!ganttId) {
    if (!ganttViewModel.isMultiview()) {
      return '';
    }

    if (task.type === constants.TASK_TYPES.project) {
      ganttId = globalStore.getters['tasksModel/getTask'](task.id)?.gantt_id;
      totalPrice = getPriceForProjectTask(task, ganttId);
    }
  } else if (task.type === constants.TASK_TYPES.project) {
    if (isBaseline) {
      const baselineData = baselineModelState || globalStore.getters['baselines/getActiveBaselineData'](ganttId);
      const originalChildren = globalStore.getters['tasksModel/getAllChildByTask'](ganttId, task.id);

      _.each(originalChildren, child => {
        const baselineTask = _.find(baselineData?.tasks, bt => bt.id === child.id);

        if (baselineTask && baselineTask.type !== constants.TASK_TYPES.button) {
          // if (baselineTask.type !== constants.TASK_TYPES.project && baselineTask.resources && baselineTask.resources.length) {
          if (baselineTask.type !== constants.TASK_TYPES.project) {
            totalPrice += calculateCostChildTask(baselineTask);
          }
        }
      });
    } else {
      totalPrice = getPriceForProjectTask(task, ganttId);
    }
  } else {
    const projectAutoBudget = projectsModel.getProjectAutoBudget(ganttId);

    if ((task.resources && task.resources.length) || !projectAutoBudget) {
      totalPrice = calculateCostChildTask(task);
    }
  }

  if (!rights.project.hasCostRight(task.gantt_id)) return '';

  return totalPrice;
}
